import { useState, useContext } from "react";
import { createProduct } from "../../services/productApi";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/common/Sidebar";
import Navbar from "../../components/common/Navbar";
import { AuthContext } from "../../context/AuthContext";
import "./CreateProduct.css";

const CreateProduct = () => {
const { user } = useContext(AuthContext);
const navigate = useNavigate();

const [form, setForm] = useState({
name: "",
description: "",
price: "",
discount_percent: 0,
category_id: "",
stock_quantity: 0,
low_stock_limit: 5,
});

const [loading, setLoading] = useState(false);

// handle inputs
const handleChange = (e) => {
setForm({
...form,
[e.target.name]: e.target.value,
});
};

const handleSubmit = async (e) => {
e.preventDefault();

if (loading) return;

try {
  setLoading(true);

  // 1. CREATE PRODUCT ONLY
  const res = await createProduct({
    ...form,
    price: Number(form.price),
    stock_quantity: Number(form.stock_quantity),
    discount_percent: Number(form.discount_percent),
    category_id: form.category_id
      ? Number(form.category_id)
      : null,
  });

  const product = res?.product || res;

  if (!product?.id) {
    throw new Error("Product creation failed (no ID returned)");
  }

  alert("Product created successfully");

  // 2. REDIRECT TO IMAGE UPLOAD PAGE
  navigate(`/admin/products/${product.id}/images`);

} catch (err) {
  alert(err.response?.data?.message || err.message || "Create failed");
} finally {
  setLoading(false);
}


};

return (
<div className="create-product-layout">
<Sidebar role={user.role} />

  <div className="create-product-main">
    <Navbar />

    <div className="create-product-content">
      <div className="create-product-card">

        <div className="create-product-header">
          <h2>Create Product</h2>
          <p>
            Add product details before uploading product images.
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="create-product-form"
        >
          {/* PRODUCT NAME */}
          <div className="form-group full-width">
            <label htmlFor="name">Product Name</label>

            <input
              id="name"
              name="name"
              placeholder="Enter product name"
              onChange={handleChange}
              required
            />
          </div>

          {/* DESCRIPTION */}
          <div className="form-group full-width">
            <label htmlFor="description">Description</label>

            <textarea
              id="description"
              name="description"
              placeholder="Enter product description"
              onChange={handleChange}
              rows="5"
            />
          </div>

          {/* PRICE */}
          <div className="form-group">
            <label htmlFor="price">Price</label>

            <input
              id="price"
              name="price"
              type="number"
              placeholder="Enter price"
              onChange={handleChange}
              required
            />
          </div>

          {/* DISCOUNT */}
          <div className="form-group">
            <label htmlFor="discount_percent">
              Discount %
            </label>

            <input
              id="discount_percent"
              name="discount_percent"
              type="number"
              placeholder="Discount percentage"
              onChange={handleChange}
            />
          </div>

          {/* CATEGORY */}
          <div className="form-group">
            <label htmlFor="category_id">
              Category ID
            </label>

            <input
              id="category_id"
              name="category_id"
              type="number"
              placeholder="Enter category ID"
              onChange={handleChange}
            />
          </div>

          {/* STOCK */}
          <div className="form-group">
            <label htmlFor="stock_quantity">
              Stock Quantity
            </label>

            <input
              id="stock_quantity"
              name="stock_quantity"
              type="number"
              placeholder="Enter stock quantity"
              onChange={handleChange}
            />
          </div>

          {/* LOW STOCK */}
          <div className="form-group">
            <label htmlFor="low_stock_limit">
              Low Stock Limit
            </label>

            <input
              id="low_stock_limit"
              name="low_stock_limit"
              type="number"
              placeholder="Enter low stock limit"
              onChange={handleChange}
            />
          </div>

          {/* SUBMIT */}
          <div className="form-actions full-width">
            <button
              type="submit"
              disabled={loading}
              className="create-product-btn"
            >
              {loading
                ? "Creating..."
                : "Create Product"}
            </button>
          </div>
        </form>

      </div>
    </div>
  </div>
</div>


);
};

export default CreateProduct;